<script>
export default {
  name: 'VideoLoading',
};
</script>

<template>
  <div class="video-loading-indicator__wrapper">
    <span class="video-loading-indicator__circle video-loading-indicator__left"></span>
    <span class="video-loading-indicator__circle video-loading-indicator__middle"></span>
    <span class="video-loading-indicator__circle video-loading-indicator__right"></span>
  </div>
</template>
